import React from "react";
import { LayoutDashboard, User, Flag, Ticket,CircleUser } from "lucide-react";

const AdminSidebar = ({ active, setActive,unreadCount }) => {
  const styles = {
      body:{
margin:"0",
 padding: "0",
  minheight: "100%",
  background: "#f5f6fa"
    },
    container: {
      width: "280px",
      background: "#0f0f2d",
      color: "#fff",
      padding: "20px",
      flexshrink:"0",
      height:"100vh"
    },
    item: {
      position:"relative",
      padding: "14px",
      borderRadius: "10px",
      marginBottom: "10px",
      cursor: "pointer",
    },
    active: {
      background: "#5b2dab",
    },
    sidebar:{
        display:"flex",
        AlignCenter:"center",
        gap:"10px"
    },
    sidebarnotificationdot:{
   position: "absolute",
  top: "8px",
  right: "1px",
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  background: "#ef4444",
  boxShadow: "0 0 0 2px white"
}
  };

 const Item = ({ label, id, icon: Icon,unreadcount }) => (
  <div
    onClick={() => setActive(id)}
    style={{
      ...styles.item,
      ...(active === id ? styles.active : {}),
      display: "flex",
      alignItems: "center",
      gap: "12px",
    }}
  >
    <Icon size={18} />
   <div>
{id === "contact" && unreadCount > 0 && (
  <span style={styles.sidebarnotificationdot} className="sidebarnotificationdot"></span>
)}
    {label}
   </div>
  </div>
 );

  return (
    <div style={styles.container}>
      {/* <h3>CodeMatrix</h3> */}
      <img id="logoimg" src="codematrixLogo.png" alt="logo" />

<br/>
<br/>

 <Item label="Dashboard" id="dashboard" icon={LayoutDashboard} />
<Item label="User profile" id="profile" icon={User} />
<Item label="Blocked Users" id="flagged" icon={Flag} />
<Item label="Support Ticket" id="support" icon={Ticket} />
<Item label="Contact Details" unreadCount={unreadCount} id="contact" icon={CircleUser} />
    </div>
  );
};

export default AdminSidebar;